import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import styled from "styled-components";
import CustomText from "pages/_components/CustomText/CustomText";
import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import { goBack, push } from "connected-react-router";
import { Col } from "react-bootstrap";
import { actions, selectors } from "reducers/softToken";
import Button from "pages/_components/Button";
import { bool, func, shape, string } from "prop-types";
import * as config from "util/config";
import { ResponsiveHeader } from "pages/_components/header";
import Image from "pages/_components/Image";
import * as i18nUtils from "util/i18n";

const TimerWrapper = styled.div`
    > div {
        width: 100% !important;
        display: flex;
        justify-content: center;
    }
    path:last-child {
        stroke: ${(props) => props.theme.primaryColor};
        stroke-linecap: unset;
    }
`;
const colores = ["#35EEC8", "#35EEC8", "#C20E1A", "#C20E1A"];
const TokenVirtual = ({ isMobile, getTokenInfo, tokenInfo, deviceStatus, fetching }) => {
    const dispatch = useDispatch();
    const [seconds] = useState(config.getInteger("softToken.time.counter", 30));
    const [countdownCircle, setCountdownCircle] = useState(undefined);
    const [contador, setcontador] = useState(0);
    const [validateError, setvalidateError] = useState(false);
    const [datoGenerador, setdatoGenerador] = useState(false);

    useEffect(() => {
        getTokenInfo();
    }, []);

    useEffect(() => {
        if (deviceStatus !== "SUCCESS") {
            setvalidateError(true);
        } else {
            setvalidateError(false);
        }
    }, [deviceStatus]);

    useEffect(() => {
        if (tokenInfo) {
            const { token, remainingTime1 } = tokenInfo;

            const renderTime = ({ remainingTime }) => {
                setcontador(remainingTime);
                if (remainingTime === 0) {
                    return <div className="timer" />;
                }
                return (
                    <div>
                        <h1 style={{ textAlign: "center", fontSize: "30px" }}>
                            <b>{token}</b>
                        </h1>
                    </div>
                );
            };
            const handleOnComplete = () => {
                getTokenInfo();
                // Aqui llamar al action para generar el nuevo token
                return { shouldRepeat: true, delay: 0.5 };
            };
            const countdown = () => (
                <CountdownCircleTimer
                    isPlaying
                    duration={seconds}
                    initialRemainingTime={remainingTime1}
                    colors={colores}
                    colorsTime={[30, 15, 10, 0]}
                    onComplete={handleOnComplete}>
                    {renderTime}
                </CountdownCircleTimer>
            );
            setCountdownCircle(countdown());
        }
        return () => setCountdownCircle(undefined);
    }, [tokenInfo, datoGenerador]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const newTokenGenerator = () => {
        setCountdownCircle(undefined);
        getTokenInfo();
        setdatoGenerador(!datoGenerador);
    };

    if (validateError) {
        return (
            <>
                {isMobile && (
                    <ResponsiveHeader id="login.softToken.title" onClickBack={onHeaderBack} showCenterContent />
                )}
                <MainContainer showLoader={fetching}>
                    {!isMobile && <Head id="login.softToken.title" onBack={isMobile && onHeaderBack} />}
                    {/* {!isMobile && (
                        <Container>
                            <Col xs={12} md={8} mdOffset={2}>
                                <Head titleText="Token de seguridad" onBack={isMobile && onHeaderBack} />
                            </Col>
                        </Container>
                    )} */}
                    <div>
                        <Col xs={12} md={8} mdOffset={2}>
                            <h1 className="text-center">
                                <CustomText text={i18nUtils.get("error.title", "Ha ocurrido un error")} />
                            </h1>
                        </Col>
                        <div className="ilustracion text-center">
                            <Image src="figma/illustrations/onboarding13.svg" className="svg-image logo" />
                        </div>
                        <br />
                        <Col xs={12} md={8} mdOffset={2} className="box border-soft" style={{ padding: "20px" }}>
                            {deviceStatus === "NOT_PHONE" ? (
                                <CustomText text={i18nUtils.get("token.not.phone")} />
                            ) : (
                                <CustomText text={i18nUtils.get("token.not.registered.device")} />
                            )}
                        </Col>
                        <Button
                            className="mt-8"
                            bsStyle="primary"
                            label="global.accept"
                            loading={false}
                            onClick={() => {
                                setvalidateError(false);
                                dispatch(push("/"));
                            }}
                        />
                    </div>
                </MainContainer>
            </>
        );
    }

    return (
        <>
            {isMobile && <ResponsiveHeader id="login.softToken.title" onClickBack={onHeaderBack} showCenterContent />}
            <MainContainer showLoader={fetching}>
                {!isMobile && <Head title="login.softToken.title" onBack={onHeaderBack} />}
                <CustomText style={{ textAlign: "center" }} text="login.softToken.subtitle" textType="I18N" />
                {countdownCircle ? <TimerWrapper>{countdownCircle}</TimerWrapper> : null}
                <span
                    className="value"
                    style={{
                        textAlign: "center",
                        color: colores[contador > 15 ? 0 : () => (contador < 15 ? 2 : 0)],
                    }}>
                    {contador} segundos restantes.
                </span>
                <div style={{ paddingTop: "150px" }} />

                <Button
                    className="mt-8"
                    bsStyle="primary"
                    style={{ marginTop: "50px" }}
                    defaultLabelText="Generar nuevo token"
                    onClick={newTokenGenerator}
                    block
                />
            </MainContainer>
        </>
    );
};

TokenVirtual.propTypes = {
    isMobile: bool.isRequired,
    getTokenInfo: func.isRequired,
    tokenInfo: shape({}),
    deviceStatus: string,
    fetching: bool.isRequired,
};

TokenVirtual.defaultProps = {
    tokenInfo: undefined,
    deviceStatus: "",
};

const mapStateToProps = (state) => ({
    tokenInfo: selectors.getTokenInfo(state),
    deviceStatus: selectors.getDeviceStatus(state),
    fetching: selectors.getFetching(state),
});

const mapDispatchToProps = (dispatch) => ({
    getTokenInfo: () => {
        dispatch(actions.getTokenInfo());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(TokenVirtual);
